<template>
  <TTooltip
    :title="title"
    :content="content"
    :modal-type="modalType"
  >
    <TIcon
      :icon="icon"
      :size="iconSize"
      :class="computedClasses"
    />
    <template #content>
      <slot name="content" />
    </template>
  </TTooltip>
</template>

<script setup lang="ts">
import type { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import type { TooltipIconSize, TooltipIconVariant, TooltipModalType } from './types'

const props = withDefaults(defineProps<{
  content?: string
  title: string
  icon?: [IconPrefix, IconName]
  iconVariant?: TooltipIconVariant
  iconSize?: TooltipIconSize
  modalType?: TooltipModalType
}>(), {
  icon: () => ['far', 'circle-question'],
  iconVariant: 'highlight',
  iconSize: 'md',
  modalType: 'info',
})

const computedClasses = computed(() => ([
  {
    'text-secondary': props.iconVariant === 'highlight',
    'text-primary-950': props.iconVariant === 'primary',
    'text-gray-500': props.iconVariant === 'muted',
  },
]))
</script>
